/*** Vendor ***/
require('./00-vendor/jquery');
require('./00-vendor/bootstrap');
require('./00-vendor/pnotify');
require('./00-vendor/select2');
require('./00-vendor/typeahead');
require('./00-vendor/cookies');
require('./00-vendor/jquery-confirm');
require('./00-vendor/moment');
require('./00-vendor/gsap');
require('slick-carousel');

/*** Own ***/
require('./01-settings/ajax');
require('./06-components/carousel');
require('./06-components/banner-popup');
require('./06-components/cookies');
require('./06-components/direccion');
require('./06-components/dp-slider');
require('./06-components/menu-top');
require('./06-components/menu-middle');
require('./06-components/menu-bottom');
require('./06-components/view');
require('./06-components/order');
require('./06-components/solr');
require('./06-components/facet');
require('./06-components/filter');
require('./06-components/pedidos');
require('./06-components/pedir-todo');
require('./06-components/pie');
require('./06-components/porcentaje-beneficio');
require('./06-components/plantilla');
require('./06-components/tooltips');
require('./07-utilities/utility');
require('./07-utilities/conversion');
require('./07-utilities/feedback');
require('./07-utilities/storage');
require('./07-utilities/exports');
require('./07-utilities/url-search-params');
require('./07-utilities/google-recaptcha-v3');
// require('./main');
